module.exports = __webpack_public_path__ + "img/loading.f864cbf3.gif";